import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	isOpen: false,
	isBasicModal: false,
	isLargeModal: false,
	title: "",
};

const modalSlice = createSlice({
	name: "modal",
	initialState,
	reducers: {
		showModal: (state) => {
			state.isOpen = true;
		},
		hideModal: (state) => {
			state.isOpen = false;
			state.title = "";
		},
		basicModalShowHide: (state) => {
			state.isBasicModal = !state.isBasicModal;
		},
		largeModalShowHide: (state) => {
			state.isLargeModal = !state.isLargeModal;
		},
		setTitle: (state, { payload }) => {
			state.title = payload;
		},
	},
});

export default modalSlice.reducer;
export const { showModal, hideModal, basicModalShowHide, setTitle, largeModalShowHide } =
	modalSlice.actions;
